import React, { Component } from 'react';

class SelectComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedValue: props.prevSelectedValue || ''
        };
    }

    handleSelectedValueChange = event => {
        const { value } = event.target;
        this.setState({
            selectedValue: value
        });
        this.props.onSelectedValueChange(value, true);
    }
        
    render() {
        const { labels, values, prevSelectedValue, currentIndex, onSelectedValueChange } = this.props;
        const { selectedValue } = this.state;

        return (
            <div className="roomForAnswers" id={currentIndex}>
                <select
                    className='bubbleSelect'
                    value={selectedValue}
                    onChange={this.handleSelectedValueChange}
                >
                    <option value="">Treffen Sie Ihre Auswahl</option>
                    {labels.map((label, index) => (
                        <option key={index} value={values[index]}>{label}</option>
                    ))}
                </select>
            </div>
        );
    }
}

export default SelectComponent;